module.exports = __webpack_public_path__ + "img/stock1.d30fccd4.png";